<template>
  <v-card style="max-height: 2000px;">
    <v-card-title class="layout justify-center" >
    <h1 class="headline">{{$tf('PrivacyPolicy')}}</h1>
      </v-card-title>
    <v-card-text class="pa-0" id="wrapperFrame" style="margin-left: 10px;">
      <v-container class="fill-height">
        <v-row>
          <v-col>
    <iframe id="termsFrame" :src="`/privacy/${fallbackedLocale}.html`" frameborder="0" height="100" width="100%" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="pt-0 mr-2">
      <div class="flex-grow-1"></div>
      <v-btn small color="primary" @click="$root.$emit('closeDialog')">
        {{'Ok'}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import useLanguageTree from '../../commons/language'

const { getAvailableLangByCondition } = useLanguageTree()
export default {
  name: 'policy',
  computed: {
    locale () {
      return this.$i18n.locale || this.$i18n.fallbackLocale
    }
  },
  data () {
    return {
      fallbackedLocale: ''
    }
  },
  watch: {
    locale: {
      immediate: true,
      handler: async function (val) {
        getAvailableLangByCondition(val, this.isURLFound).then(response => {
          this.fallbackedLocale = response
        })
      }
    }
  },
  methods: {
    isURLFound: function (locale) {
      let url = '/privacy/' + locale + '.html'
      if (locale === '') {
        return new Promise(resolve => resolve())
      }
      return fetch(url, {
        method: 'HEAD',
        cache: 'no-cache'
      }).then((response) => {
        return response.status === 200 ? locale : false
      }).catch(error => {
        this.$log.error(error)
        return false
      })
    }
  }
}
</script>

<style>
  #wrapperFrame{
    width: calc(100% - 10px);
  }
  #termsFrame{
    width: calc(100% - 10px);
    min-height: 43vh;
  }
</style>
